import React from 'react'
import ButtonCta from '@components/atoms/button-cta'
import PropTypes from 'prop-types'
import useStyles from './info-and-image-card.styles'

const InfoAndImageCard = (props) => {
  const {
    heading,
    subheading,
    cardImage,
    ctaText,
    ctaLink,
    largeCardVariant,
  } = props

  const styles = useStyles({ largeCardVariant })

  return (
    <div className={styles.infoCard}>
      <img className={styles.img} src={cardImage.url} alt={cardImage.description} />
      <div className={styles.copyContainer}>
        <h3 className={styles.copyHeading}>{heading}</h3>
        <h4 className={styles.copySubheading}>{subheading}</h4>
        <ButtonCta className={styles.buttonCta} href={ctaLink} arrow>{ctaText}</ButtonCta>
      </div>
    </div>
  )
}

InfoAndImageCard.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  cardImage: PropTypes.object,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  largeCardVariant: PropTypes.bool,
}

InfoAndImageCard.defaultProps = {}

export default InfoAndImageCard
